import { useState } from 'react';

import { RowSelectionState } from '@tanstack/react-table';
import { Link, useParams } from 'react-router-dom';

import { SettingsHeader } from './components/settings-header';
import { DocsTable } from '../docs/components/docs-table';
import { useGetMatterDocsWithCases } from '@/api/queries/useGetMatterDocsWithCases';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';

export function DocumentManagement() {
  const { matterId } = useParams();
  if (!matterId) return null;

  const { data: matter } = useGetMatterV2(matterId);
  const { data: docs, isLoading } = useGetMatterDocsWithCases(matterId);

  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  return (
    <>
      <SettingsHeader
        title="Document Management"
        subheading={
          <p className="text-sm text-gray-500">
            View and manage all documents uploaded to {matter?.name ?? 'this matter'}.
          </p>
        }
        action={
          <Button asChild variant="primary">
            <Link to={`/matters/${matterId}/docs/upload`}>
              <Icon className="lucide--file-up" />
              <span>Upload Documents</span>
            </Link>
          </Button>
        }
      />

      <DocsTable docs={docs} rowSelection={rowSelection} onRowSelectionChange={setRowSelection} isLoading={isLoading} />
    </>
  );
}
